module.exports = __webpack_public_path__ + "static/media/bg-innovation.cea8e786.jpg";